import Button from "../components/ui/Button";
import { useState, useEffect } from "react";
import StrokeTitle from "../components/ui/StrokeTitle";
import CharacterModal from "../components/ui/CharacterModal";
import { useLocation } from "react-router-dom";
import '../styles/pages/characters.scss'
import FlowerTitle from "../components/ui/FlowerTitle";


const Characters = () => {

  
  const [page, setPage] = useState("main")

  return (
    <div className="page-container">
      
      <FlowerTitle text="Personnages"/>
      <nav className="page-nav">
        <Button text="Personnages principaux" color="green" onClick={()=>setPage("main")}/>
        <Button text="Personnages communs" color="blue" onClick={()=>setPage("other")}/>
      </nav>
      {
        page === "main" ? <MainCharacters/> : <OtherCharacters/>
      }
      <nav className="page-nav">
        <Button text="Personnages principaux" color="green" onClick={()=>setPage("main")}/>
        <Button text="Personnages communs" color="blue" onClick={()=>setPage("other")}/>
      </nav>
    </div>
  )
}

const MainCharacters = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 6
  });

  const [modal2, setModal2] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 2
  });

  const location = useLocation();
  
  useEffect(() => {    
      // Get the hash without the # symbol
      const hash = location.hash.slice(1);
      
      // Only run character-specific code if there's a hash
      if (hash) {
        console.log(`Character selected: ${hash}`);
        
        // Add your character-specific code here based on the hash
        switch(hash) {
          case 'fuji':
            setModal({
              ...modal,
              'visible': true,
              'current': 0,
            })
            break;
          case 'pirilika':
            setModal({
              ...modal,
              'visible': true,
              'current': 1,
            })
            break;
            case 'ao':
            setModal({
              ...modal,
              'visible': true,
              'current': 2,
            })
            break;
            case 'yeyasu':
            setModal({
              ...modal,
              'visible': true,
              'current': 3,
            })
            break;
            case 'ceefore':
            setModal({
              ...modal,
              'visible': true,
              'current': 4,
            })
            break;
            case 'suisen':
            setModal({
              ...modal,
              'visible': true,
              'current': 5,
            })
            break;
            case 'higan':
            setModal({
              ...modal,
              'visible': true,
              'current': 6,
            })
            break;
          default:
        }
      }
  }, [location, modal]); // Re-run whenever the URL changes
  
  return (
    <>
      <CharacterModal modal={modal} setModal={setModal} url="img_main_.png" characters={mainCharacters}/>
      <StrokeTitle text="Personnages principaux"/>
      <div className="character-list">
      {
        mainCharacters.map((char, index)=>(
          <div className="character-button">
            <img src={`${process.env.PUBLIC_URL}/img/characters/icon_main_0${index+1}.png`} alt="" className="character-icon" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': index,
                  }
                )
              }}
            />
          </div>
        ))
      }
      </div>

      <CharacterModal modal={modal2} setModal={setModal2} url="img_sub_.png" characters={otherCharacters}/>
      <StrokeTitle text="Personnages secondaires"/>
      <div className="character-list">
      {
        otherCharacters.map((char, index)=>(
          <div className="character-button">
            <img src={`${process.env.PUBLIC_URL}/img/characters/icon_sub_0${index+1}.png`} alt="" className="character-icon" 
              onClick={()=>{
                setModal2(
                  {
                    ...modal2,
                    'visible': true,
                    'current': index,
                  }
                )
              }}
            />
          </div>
        ))
      }
      </div>
    </>
  )
}

const OtherCharacters = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 1,
    url: "",
    size: 44
  });
  
  return (
    <>
      <CharacterModal modal={modal} setModal={setModal} url="img_generic_.png" characters={genericCharacters}/>
      <StrokeTitle text="Personnages communs"/>
      <div className="character-list">
      {
        genericCharacters.map((char, index)=>(
          <div className="character-button">
            <img src={`${process.env.PUBLIC_URL}/img/characters/icon_generic_${index < 9 ? "0"+(index+1) : (index+1)}.png`} alt="" className="character-icon" 
              onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': index,
                  }
                )
              }}
            />
            <h2>
              
            </h2>
          </div>
        ))
      }
      </div>
    </>
  )
}

const mainCharacters = [
  {
    name: "Fuji",
    desc: "Le bushi errant et allergique à la compassion...",
    para: `Un démon au caractère diaboliquement cruel, véritable condensé d'hérésie, de cupidité et de paresse.
    Son mot d'ordre : « Les vainqueurs sont des héros, les vaincus des zéros ». Pour gagner, tous les coups sont bons, même les plus bas.
    Il est atteint d'une allergie aiguë à la compassion, et tout ce qui touche de près ou de loin à l'amour, l'amitié ou la pitié lui fait automatiquement cracher tout son sang.`,
    catch: `C'est parti pour l'hécatombe !!`
  },
  {
    name: "Pirilika",
    desc: "La fangirl ultime de Hinomoto, toute gentille avec tout le monde...",
    para: `Demoiselle de bonne famille originaire du Sous-Monde de la Paix.
    Fan ultime de la province de Hinomoto, elle a la particularité d'aduler à sa façon le Bushido. Elle voit le bien partout et est incapable de penser qu'une personne pourrait être intrinsèquement mauvaise.`,
    catch: `Ooh, splendide ! Voilà donc à quoi ressemble la prosternation traditionnelle de Hinomoto,
    le dowgeza !`
  },
  {
    name: "Ao",
    desc: "La mystérieuse petite fille qui prétend être la fille de Fuji...",
    para: `Petite fille dont personne ne sait rien et qui ne cesse de dire qu'elle est la fille de Fuji. Toujours en train d'essayer d'attirer l'attention de ce dernier, elle est en revanche sans pitié pour tous ceux qui se dressent sur son chemin et n'hésite pas à réduire en bouillie ceux qu'elle considère comme des gêneurs.`,
    catch: `Papa, papa, tu me sers très fort dans tes bras, dis? Tu sais que je t'aime tellement, mon papa adoré ♡`
  },
  {
    name: "Oyéyasu",
    desc: "Shogun dégénéré",
    para: `Trouillard, lavette et narcissique, c'est pourtant bien lui, le shogun du Showgunat.
    Coureur de jupons, il passe ses journées à dépenser sa fortune auprès de charmantes Maikos, mais possède tout de même une des Sept Armes fondatrices, Tokugawa Tenge, le sceptre démoniaque.`,
    catch: `Hu ha ha ha! Ouais ouais ! Venez donc admirer mon swag ! `
  },
  {
    name: "Cyphore",
    desc: "Noble voleuse qui aime les explosifs",
    para: `Plus connue dans tout Hinomoto sous son surnom de « La Flibujusticière Mouse★Girl », c'est une fan d'armes anciennes, qui perd le contrôle de sa raison dès qu'elle renifle l'odeur de la poudre à canon.
    Elle est à la recherche des Reliques infernales pour une raison que personne ne semble connaître...`,
    catch: `Fififi ! J’aime cette énergie ! Je suis super motivée maintenant ! »`
  },
  {
    name: "Suisen",
    desc: "L'arme humanoïde capable de prévoir le futur...",
    para: `Magistrat de la Prémonition à la solde du Showgunat, c'est une arme humanoïde à l'apparence d'un jeune garçon. Sa force est dévastatrice et son pouvoir de prémonition du futur en fait un adversaire redoutable.
    Il parle sur un ton généralement monocorde, tel un robot (qu'il est), mais fait parfois preuve de l'innocence des jeunes garçons de son âge.`,
    catch: `Moi, Suisen, le Magistrat de la Prémonition, vais maintenant vous achever.`
  },
  {
    name: "Higan Zesshôsai",
    desc: "La plus grande épéiste de tout Hinomoto, fatiguée de son épée...",
    para: `Dernière descendante des plus grands épéistes de Hinomoto, au prestigieux titre de « Zesshôsai ». C'est également l'ancien maître d'armes de Fuji.
    Trop puissante avec son épée, elle la délaisse volontairement pour se consacrer au maniement de la lance.`,
    catch: `Je suis Higan Zesshôsai... Et c’est la mort qui attend ceux qui osent se mettre sur mon chemin !`
  }
]

const otherCharacters = [
  {
    name: "Piichan",
    para: `Prinny et secrétaire attitré de Pirilika depuis qu'elle est toute petite.
    Il excelle dans son travail, un peu trop d'ailleurs, au point de paraître parfois un peu froid et insensible.
    Ne fait JAMAIS rien qui puisse sortir des tâches qu'il est censé exécuter. Il lui arrive aussi parfois de s'enfuir en laissant en plan sa maîtresse...`,
  },
  {
    name: "Nitra",
    para: `Ange secouru par Fuji alors qu'elle était attaquée par le Showgunat.
    Personne ne connaît les raisons de sa présence dans le Sous-Monde, et elle semble cacher de nombreux secrets...`,
  },
  {
    name: "Le Grand Amiral Expandor",
    para: `Grand chef de l'Armée du Sous-Monde, un bataillon de démons surentraînés au combat. Il envahit Hinomoto et tente par tous les moyens de faire disparaître les valeurs traditionnelles du Bushido qui caractérisent la province.
    C'est également le possesseur d'une Arme fondatrice, le poing démoniaque, avec lequel il contrôle tous les bushis de Hinomoto.`,
  }
]

const genericCharacters = [
{
    desc: "La fleur dansante de Hinomoto",
    name: "Maiko",
    para: `Jolie petite danseuse de la cour du shogun, c'est un vrai petit démon dont les attaques sur la gent masculine sont particulièrement redoutables. Mais elle est tellement mignonne qu'on lui pardonne.`},
{
    desc: "La chasse aux trésors ? C'est pour lui !",
    name:"Voleur",
    para: `Sa spécialité : retrouver les meilleurs trésors cachés un peu partout. Il ne laisse passer aucun coffre !
    Son objectif : devenir un voleur encore plus renommé que son père.`},
{
    desc: "Au sang chaud et au poing facile",
    name:"Guerrier",
    para: `Un guerrier à la musculature de rêve et au tempérament bien trempé.
    Sa confiance en ses muscles lui permet de se sortir des situations les plus critiques. `},
{
    desc: "Toujours de bonne humeur pour se battre",
    name: "Guerrière",
    para: `Guerrière à la force et à la dextérité à toute épreuve. Ses attaques sont foudroyantes. Même si c'est un soldat hors pair, elle sait garder une âme de jeune fille en fleur.`},
{
    desc: "Le combat rapproché n'a pas de secret pour lui",
    name:"Moine",
    para: `Moine rompu aux techniques de combat au corps à corps. Il maîtrise à la perfection les ripostes. Sa tenue est un reste de l'héritage de ses ancêtres.`},
{
    desc: "Déstabiliser ses adversaires, c'est son truc",
    name:"Moniale",
    para: `Une guerrière moine, aux techniques de combat raffinées et élégantes. Elle sait dévier les attaques de ses adversaires avec une efficacité redoutable. Elle vit dans le fin fond de la campagne de Hinomoto.`},
{
    desc: "Puissance de feu fatale !",
    name:"Sorcier",
    para: `Un jeune garçon très sérieux et capable d'utiliser des sorts de magie d'une extrême puissance.
    Sa capuche en forme de tête de mort lui donne un mauvais genre, et il ne la met que rarement.`},
{
    desc: "La meilleure pour les attaques à portée",
    name: "Sorcière",
    para: `Petite fille naïve et innocente, adepte de la magie.
    Elle est très douée pour jeter des sorts, d'ailleurs...
    Son ruban lui sert paraît-il à emmagasiner son mana.`},
{
    desc: "Besoin de soins ? Il est là pour vous.",
    name: "Clerc",
    para: `Il est persuadé que soigner quelqu'un avec ses pouvoirs est un péché et s'inflige une punition à chaque fois qu'il le fait.`},
{
    desc: "Elle viendra vous sauver sur le fil de la mort",
    name: "Prêtresse",
    para: `Prêtresse toujours là pour soigner ses alliés blessés.
    Elle garde les yeux fermés en permanence comme lui ordonne son Livre sacré.
    Contrairement aux Clercs, elle ne considère pas le fait de soigner quelqu'un comme un péché.`},
{
    desc: "Les malédictions ne lui font pas peur",
    name:"Exorciste",
    para: `Nécromancienne jetant des malédictions un peu partout autour d'elle.
    Elle vénère le dieu Dolvaky. Elle parle un langage un peu particulier, voire même complètement incompréhensible en fait.`},
{
    desc: "Épéiste aux pouvoirs magiques",
    name:"Paladine",
    para: `Guerrière capable de manipuler la magie et l'épée.
    C'est un démon, mais la loyauté est une valeur qu'elle respecte plus que tout.
    Elle possède un pouvoir mystérieux appelé Zohn.`},
{
  desc: "Une petite charogne malicieuse",
  name:"Jiangshi",
  para: `Démon réssuscité grâce à des techniques de magie.
  Elle gagne en puissance à chaque fois qu'un de ses alliés meurt, et revient à la vie à l'infini. 
  Plutôt timide... sans doute parce que son corps est encore un peu frais.`},
{
  desc: "Il va vous faire les gros yeux",
  name: "Globocule",
  para: `Il n'est pas vraiment très apprécié par ses camarades démons, mais il est plutôt haut placé dans la hiérarchie. Sa particularité : il modifie de façon aléatoire le système de défense des ennemis qui subissent ses attaques.`
},
{
  desc: "Le pire des nullos de la création",
  name:"Prinny",
  para: `Classe la plus insignifiante parmi tous les démons. Nullos parmi les nullos, il explose quand on le jette. Peau de pingouin avec l'âme d'un humain ayant commis des péchés durant sa vie, il est condamné à expier ses fautes dans la misère pour l'éternité.`},
{
  desc: "Mort-vivant fraîchement sorti de sa tombe",
  name:"Zombie",
  para: `Cadavre ressuscité, plutôt coriace mais au quotient intellectuel ridiculement faible. Capable de régénérer tout en attaquant.`},
{
  desc: "Petit farceur facétieux mais pas drôle en fait",
  name:"Mite",
  para: `Démon à l'apparence d'insecte, saupoudrant de pollen tout ce qu'il touche et infligeant des altérations d'état à tout-va, ce qui explique pourquoi même les démons préfèrent l'éviter.`},
{
  desc: "Le plus puissant des démons du Sous-Monde",
  name: "Dragon",
  para: `Créature la plus redoutable des Sous-Mondes, aussi fière que puissante. Capable d'augmenter sa puissance tout en subissant des attaques.`},
{
  desc: "Le seul capable de monter un Dragon",
  name: "Cavalier",
  para: `Chevalier incarnant à la perfection l’orgueil et la fierté des démons. Il porte une armure extrêmement résistante qui le protège de toutes les attaques physiques de ses ennemis. Redoutable quand il est utilisé en tant que bouclier.`},
{
  desc: "Attention à ses sabots ",
  name: "Catoblépas",
  para: `Créature ressemblant vaguement à un bœuf. Elle est très timide, mais sa puissance d'attaque est effrayante quand elle s'énerve, et mieux vaut rester à distance. Elle possède également le pouvoir de faire diminuer la défense de ses ennemis.`},
{
  desc: "Créature funestement porte-bonheur",
  name:"Ange de mer",
  para: `Petit papillon marin apparu à cause de la pollution de l'eau. Elle est spécialisée dans l'aide de ses camarades démons et permet de faire augmenter l'expérience de façon exponentielle.`},
{
  desc: "Une fleur dans la forêt sauvage",
  name: "Flora Beast",
  para: `Fleur poussant un peu partout dans les Sous-Mondes, au parfum envoûtant qui permet à ses alliés de regagner de l'énergie.`},
{
  desc: "Les hommes, tous les mêmes !",
  name: "Succube",
  para: `Superbe diablesse capable d’attirer n’importe quel homme dans ses filets. Elle les affaiblit pour mieux les éliminer... Elle s'entend très bien avec les Félines !`},
{
  desc: "Gros minou aux formes pulpeuses",
  name: "Féline",
  para: `Créature féline spécialisée dans les arts martiaux, à l'éventail de coups et de techniques très important.`},
{
    desc: "Bushi pris en étau entre sa fierté et la réalité",
    name:"Samouraï",
    para: `Un guerrier avec son code d’honneur et sa fierté suivant son propre Bushido. Cependant, par les temps qui courent, peu réussissent à respecter leurs principes.`},
{
    desc: "Miko à l'épée repoussant le Mal",
    name:"Lady Samouraï",
    para: `Samouraï effectuant ses tâches en dehors de Hinomoto. Super forte en combat à un contre un.`},
{
    desc: "Toujours dans l'ombre, et c'est son problème",
    name:"Ninja",
    para: `Assassin de l’ombre. Extrêmement fier, sa dextérité et sa facilité à se faufiler partout sans un bruit sont impressionnantes.`},
{
    desc: "Froide en apparence, son cœur est pur et chaste en vérité",
    name:"Kunoichi",
    para: `Assassine de l’ombre qui envoûte ses proies avec de suaves fragrances, ses capacités d'esquive sont au top.
    Toujours à la pointe de la mode.`},
{
    desc: "Impitoyable et détesté de tous",
    name:'Archer',
    para: `Froid et cruel, il ne peut pas saquer les filles plates et les archères.`},
{
    desc: "L'arc est son arme",
    name:"Archère",
    para: `Fiable et honnête, c'est une chasseuse toujours prête à risquer sa vie pour ses alliés. Sa spécialité : les attaques à distance à grands coups de flèches.`},
{
    desc: "Tireur d'élite solitaire à la veste trop courte pour l'hiver",
    name:"Flingueur",
    para: `Tueur professionnel, il ne rate JAMAIS sa cible.`},
{
    desc: "La seule chose qui l'intéresse : l'argent",
    name: "Flingueuse",
    para: `Un peu caractérielle sur les bords, elle parle d'une façon un peu... particulière. Les attaques combinées avec ses alliés, ça la connaît.`},
{
    desc: "L'idole des plus jeunes",
    name: 'Chevalier blindé',
    para: `Guerrier à l’armure renforcée, dont la spécialité est la défense. C'est aussi l'idole des plus jeunes.`},
{
    desc: "Un mur impénétrable au service de son entourage",
    name: "Chevaleresse blindée",
    para: `Guerrière à l’armure renforcée, dont la profession attire de plus en plus de jeunes filles ces dernières années.`},
{
    desc: "Fusion parfaite de la magie et de la science",
    name:"Andro-princesse",
    para: `Robot né de la fusion de la science et de la magie. Elle compte de nombreux fans, particulièrement parmi les membres des Cieux.`},
{
    desc: "La pitié des Cieux au service de ses alliés",
    name:"Ange soldat",
    para: `Plutôt têtue pour un ange mais très efficace en combat, elle peut réduire les dégâts des alliés proches.`},
{
  desc: "Entre destruction et chaos",
  name:"Carabinodémon",
  para: `Majin venant d’une dimension parallèle avec un canon à la place d’un bras. Sa puissance de destruction est incomparable. En revanche, il est connu pour ne rien tolérer, pas même son corps customisé en arme.`},
{
  desc: "Un gentleman à la carapace stylée",
  name: "Crustacé",
  para: `Véritable gentilhomme, sa carapace est des plus raffinées. Il possède la particularité de voir sa puissance de défense augmenter à chaque fois qu'il subit une attaque.`},
{
  desc: "Créature mystérieuse semblable à un chat",
  name: "Chalangui",
  para: `Elle charme ses adversaires pour faire baisser leur garde. Elle cherche toujours à être le centre de l’attention. Elle résiste particulièrement bien aux attaques des humanoïdes.`},
{
  desc: "C'est moi le vrai champi-on !",
  name:"Champignon",
  para: `Créature adorant les endroits humides. Il n'est pas originaire du Sous-Monde. Il est capable de faire diminuer les statistiques des personnages féminins proches d'elle.`},
{
  desc: "Des pouvoirs surpassant l'entendement",
  name:"Psychique",
  para: `Il est capable de prendre le contrôle des ennemis qui l'attaquent, ainsi que de faire diminuer leurs aptitudes de mouvement. Il possède également un super pouvoir de téléportation, arme très efficace sur le champ de bataille.`},
{
  desc: "On recherche un cobaye pour expérimentation",
  name:'Savante',
  para: `Chercheuse en magie, toujours à la recherche de cobayes pour effectuer ses expériences.`},
{
  desc: "La chapardeuse des champs de bataille",
  name:"Voleuse",
  para: `Voleuse prête à tout pour récupérer tous les trésors qu’elle croise sur son chemin, elle est très fière de ses compétences de vol.`},
{
  desc: "Petit plaisantin qui ne manque pas d'esprit",
  name:"Esprit",
  para: `Fantôme farceur aux pouvoirs magiques non négligeables. Il a l'air innocent comme ça, mais ce n'est que pour mieux vous faire baisser votre garde. Attention, il déteste qu'on essaie de lui enlever son manteau !`},
{
  desc: "Turbulent et bagarreur, la teigne du Sous-Monde",
  name:"Orque",
  para: `Il peut avoir l’air chétif, il est toutefois assez brave pour s’attaquer à plus grand que lui. Il augmente ses statistiques lorsqu’il est proche de ses alliés.`},
{
  desc: "Rambunctious Hooligan",
  name:"Orc",
  para: `Trublion du Sous-Monde, il ne paie pas de mine mais est coriace comme un cafard et courageux au possible. Ses statistiques augmentent quand il est à côté d'alliés.`
}
]

export default Characters;